import { Button, Tooltip } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import type { PosTabState } from '../hooks/usePosTabs';
import { MAX_TABS } from '../hooks/usePosTabs';

interface Props {
  tabs: PosTabState[];
  activeId: string;
  canAddMore: boolean;
  disabled?: boolean;
  onSwitch: (id: string) => void;
  onAdd: () => void;
  onCloseRequest: (id: string) => void;
}

export function PosTabsBar({
  tabs,
  activeId,
  canAddMore,
  disabled = false,
  onSwitch,
  onAdd,
  onCloseRequest,
}: Props) {
  return (
    <div
      style={{
        width: '100%',
        height: 40,
        background: '#fafafa',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        gap: 4,
        overflowX: 'auto',
        overflowY: 'hidden',
        flexShrink: 0,
      }}
    >
      {tabs.map((t) => {
        const isActive = t.id === activeId;
        return (
          <div
            key={t.id}
            onClick={() => {
              if (!disabled) onSwitch(t.id);
            }}
            style={{
              height: 32,
              padding: '0 10px 0 14px',
              borderRadius: '6px 6px 0 0',
              background: isActive ? '#fff' : 'transparent',
              border: isActive ? '1px solid #e0e0e0' : '1px solid transparent',
              borderBottom: 'none',
              marginBottom: -1,
              color: isActive ? '#a4193d' : '#666',
              fontWeight: isActive ? 600 : 400,
              fontSize: 13,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled && !isActive ? 0.6 : 1,
              maxWidth: 160,
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {t.name}
            </span>
            <Tooltip title="Đóng đơn (F2)">
              <Button
                type="text"
                size="small"
                aria-label={`Đóng đơn ${t.name}`}
                icon={<CloseOutlined style={{ fontSize: 10 }} />}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!disabled) onCloseRequest(t.id);
                }}
                disabled={disabled}
                style={{
                  width: 18,
                  height: 18,
                  minWidth: 18,
                  padding: 0,
                  opacity: 0.6,
                }}
              />
            </Tooltip>
          </div>
        );
      })}
      <Tooltip title={canAddMore ? 'Thêm đơn (F1)' : `Tối đa ${MAX_TABS} đơn`}>
        <span style={{ display: 'inline-block', marginLeft: 4 }}>
          <Button
            type="text"
            size="small"
            aria-label="Thêm đơn"
            icon={<PlusOutlined />}
            onClick={onAdd}
            disabled={!canAddMore || disabled}
            style={{ height: 28 }}
          />
        </span>
      </Tooltip>
    </div>
  );
}
